import { Link } from 'react-router-dom'
import { Mail, Phone, Shield } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const signatureServices = [
    { name: 'Technology Concierge', href: '/services/technology-concierge' },
    { name: 'White Glove Service', href: '/services/white-glove-service' },
    { name: 'Technology Magic', href: '/services/technology-magic' },
  ]

  const managedServices = [
    { name: 'Managed Security', href: '/services/managed-security' },
    { name: 'Managed Desktops', href: '/services/managed-desktops' },
    { name: 'Managed Help Desk', href: '/services/managed-help-desk' },
    { name: 'Network Operations', href: '/services/network-operations' },
    { name: 'Development Services', href: '/services/development-services' },
    { name: 'Project Recovery', href: '/services/project-recovery' },
  ]

  const company = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' },
  ]

  return (
    <footer className="bg-secondary-900 text-white border-t border-primary-500/20">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/logo/Logo-Praetorian_Works-Square-235_x_235.png" 
                alt="Praetorian Works" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <span className="text-lg font-bold" style={{ color: '#ebd184' }}>Praetorian</span>
                <span className="text-lg font-light ml-1" style={{ color: '#825926' }}>Works</span>
              </div>
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed">
              Elite technology services for high net worth and ultra-high net worth individuals. 
              Discretion, excellence, and VIP treatment in every interaction.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-neutral-400">
                <Mail className="w-4 h-4 text-primary-500" />
                <span className="text-sm">ContactUs@praetorian.works</span>
              </div>
              <div className="flex items-center space-x-2 text-neutral-400">
                <Phone className="w-4 h-4 text-primary-500" />
                <span className="text-sm">+1 (408) 634-9679</span>
              </div>
              <div className="flex items-center space-x-2 text-neutral-400">
                <Shield className="w-4 h-4 text-primary-500" />
                <span className="text-sm">24/7/365 Availability</span>
              </div>
            </div>
          </div>

          {/* Signature Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-primary-500">Signature Services</h4>
            <ul className="space-y-2">
              {signatureServices.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Managed Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-primary-500">Managed Services</h4>
            <ul className="space-y-2">
              {managedServices.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-primary-500">Company</h4>
            <ul className="space-y-2">
              {company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-neutral-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            
            {/* Powered By Section */}
            <div className="pt-6 space-y-2">
              <p className="text-xs text-neutral-500 uppercase tracking-wide">Powered By</p>
              <p className="text-sm text-neutral-400">
                <span className="text-white">Disruption</span>
                <span className="text-neutral-500"> Consulting</span>
              </p>
              <p className="text-xs text-neutral-500">30+ Years of Excellence</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-primary-500/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-neutral-500 text-sm">
            © {currentYear} Praetorian Works. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/privacy" className="text-neutral-500 hover:text-primary-400 transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-neutral-500 hover:text-primary-400 transition-colors duration-200">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
